import { SkeletonTable, SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

import { QueryError } from 'common/components/QueryError';
import { QuerySuspense } from 'common/components/QuerySuspense';
import { type InfiniteQueryState } from 'src/core/api/queryState';

import { BreakdownSpendingSectionContent } from './BreakdownSpendingSectionContent';
import { type BreakdownPart } from '../../../../models/breakdown';
import {
  type BreakdownSpending,
  type SpendingType,
} from '../../../../models/breakdownSpending';
import { type SpendingClickProperty } from '../../../hooks/useSpendingClick';

type Props = {
  queryState: InfiniteQueryState<BreakdownSpending[]>;
  spendingType: SpendingType;
  breakdownPart: BreakdownPart;
  spendingClick: SpendingClickProperty;
};

export const BreakdownSpendingsSectionWrapper = ({
  queryState,
  spendingType,
  breakdownPart,
  spendingClick,
}: Props) => {
  return (
    <QuerySuspense
      queryState={queryState}
      loading={<BreakdownSpendingsSectionSkeleton />}
      fallback={(error) => (
        <QueryError queryError={error} componentType="Callout" />
      )}
    >
      {(breakdownSpendings) => (
        <BreakdownSpendingSectionContent
          breakdownSpendings={breakdownSpendings}
          spendingType={spendingType}
          breakdownPart={breakdownPart}
          hasNextPage={queryState.hasNextPage}
          onFetchNextPage={queryState.fetchNextPage}
          spendingClick={spendingClick}
        />
      )}
    </QuerySuspense>
  );
};

const BreakdownSpendingsSectionSkeleton = () => {
  return (
    <>
      <SkeletonText width="130px" className="mt-24 mb-16" />
      <SkeletonTable
        numberOfRows={5}
        columns={[
          {
            cell: <SkeletonText width="80%" />,
            header: <SkeletonText width="50%" />,
            width: '420px',
          },
          ...Array.from({ length: 4 }, () => ({
            cell: <SkeletonText width="80%" />,
            header: <SkeletonText width="50%" />,
          })),
        ]}
        withColumnSeparator
        withHeader
      />
    </>
  );
};
